<template>
    <div class="description">
        <p class="description-text" :style="{color: color}">
            {{ description }}
        </p>
    </div>
</template>

<script>
    export default {
        name: 'QuestionDescription',
        props: ['description', 'color'],
        methods: {

        }
    }
</script>

<style scoped>
    .description .description-text {
        color: #90919e;
        font-size: 14px;
        line-height: 20px;
    }
</style>
